<template>
	<div>
		<a href="https://www.hofgut-durrenberg.de">
			Webseite des Hofgutes Durrenberg
		</a>
		<p class="my-6">
			Hofgut Durrenberg
			<br />
			Durrenberg 1,
			<br />
			88239 Wangen im Allgäu,
			<br />
			Deutschland
		</p>
		<SharedMaps />
	</div>
</template>

<script setup lang="ts">
// API Key AIzaSyCDFVDYCG2YGH9z7Vu7g2ZK_5uEZrbfjbI
</script>

<style scoped></style>
